

const rankingsListData = {
  transactionsData: [
    {
      color: "error",
      icon: "arrow_downward",
      name: "Netflix",
      description: "27 March 2020, at 12:30 PM",
      value: "- $ 2,500",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Apple",
      description: "23 March 2020, at 04:30 AM",
      value: "+ $ 2,000",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Partner #22213",
      description: "19 March 2020, at 02:50 AM",
      value: "- $ 1,400",
    },
  ],

  revenueData: [
    {
      color: "success",
      icon: "arrow_upward",
      name: "via PayPal",
      description: "07 June 2021, at 09:00 AM",
      value: "+ $ 4,999",
    },
    {
      color: "success",
      icon: "arrow_upward",
      name: "Partner #90211",
      description: "07 June 2021, at 05:50 AM",
      value: "+ $ 700",
    },
    {
      color: "error",
      icon: "arrow_downward",
      name: "Services",
      description: "07 June 2021, at 07:10 PM",
      value: "- $ 1,800",
    },
  ],
};

export default rankingsListData;
